const DominicanRepublicSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111336)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M0.688965 25.2168C2.53568 32.0686 7.93076 37.4638 14.7826 39.3105V25.2168H0.688965Z"
        fill="#D80027"
      />
      <path
        d="M14.7826 0.688477C7.93076 2.53512 2.53561 7.93027 0.688965 14.7821H14.7826V0.688477H14.7826Z"
        fill="#0052B4"
      />
      <path
        d="M39.3109 14.7821C37.4642 7.93027 32.0691 2.53512 25.2173 0.688477V14.7821H39.3109V14.7821Z"
        fill="#D80027"
      />
      <path
        d="M25.2173 39.3105C32.0691 37.4637 37.4642 32.0687 39.311 25.2168H25.2173V39.3105Z"
        fill="#0052B4"
      />
      <path
        d="M25.2176 20.0006C25.2176 22.8822 22.8817 25.218 20.0001 25.218C17.1187 25.218 14.7827 22.8822 14.7827 20.0006C14.7827 17.1191 20.0001 14.7832 20.0001 14.7832C20.0001 14.7832 25.2176 17.1191 25.2176 20.0006Z"
        fill="#496E2D"
      />
      <path
        d="M14.7827 20.0006C14.7827 17.1191 17.1187 14.7832 20.0001 14.7832C22.8817 14.7832 25.2176 17.1191 25.2176 20.0006"
        fill="#0052B4"
      />
      <path
        d="M17.0649 17.3916V20.6525C17.0649 22.2733 18.3788 23.5872 19.9997 23.5872C21.6206 23.5872 22.9345 22.2733 22.9345 20.6525V17.3916H17.0649Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111336">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default DominicanRepublicSvg;
